import { render, staticRenderFns } from "./ImportQuota.vue?vue&type=template&id=57912710&scoped=true"
import script from "./ImportQuota.vue?vue&type=script&lang=js"
export * from "./ImportQuota.vue?vue&type=script&lang=js"
import style0 from "./ImportQuota.vue?vue&type=style&index=0&id=57912710&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57912710",
  null
  
)

export default component.exports